.primary {
  position: fixed;
  z-index: var(--z-index-primary-nav);
  align-items: center;
  width: 100%;
  height: var(--primary-nav-height);
  top: 0;
  padding: 0 var(--spacing-m);
  background-color: var(--brand-blue-500);
  background-color: light-dark(var(--brand-blue-500), var(--brand-blue-500));
}
